export default "__VITE_ASSET__890e0563__"